module.exports = __webpack_public_path__ + "static/media/_64A3168.d0ab0339.jpg";